var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", [_vm._v("业务管理")]),
              _c("el-breadcrumb-item", [_vm._v("PO管理")]),
              _c("el-breadcrumb-item", [_vm._v("PO时效")])
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("搜索条件")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "search-container" },
          [
            _c(
              "el-form",
              {
                staticClass: "search-form",
                attrs: {
                  inline: true,
                  model: _vm.searchForm,
                  "label-width": "100px"
                }
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "建单时间" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "daterange",
                                "range-separator": "-",
                                "start-placeholder": "开始日期",
                                "end-placeholder": "结束日期",
                                "value-format": "yyyy-MM-dd"
                              },
                              on: { change: _vm.handleDateChange },
                              model: {
                                value: _vm.searchForm.createTime,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "createTime", $$v)
                                },
                                expression: "searchForm.createTime"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "工单类型" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { clearable: "", placeholder: "请选择" },
                                model: {
                                  value: _vm.searchForm.order_level,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "order_level", $$v)
                                  },
                                  expression: "searchForm.order_level"
                                }
                              },
                              _vm._l(_vm.ticketTypeOptions, function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "PO确认单" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入PO确认单" },
                              model: {
                                value: _vm.searchForm.opTicketid,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "opTicketid", $$v)
                                },
                                expression: "searchForm.opTicketid"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "PO标题" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入PO标题" },
                              model: {
                                value: _vm.searchForm.serviceInfo,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "serviceInfo", $$v)
                                },
                                expression: "searchForm.serviceInfo"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "区域园区" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { clearable: "", placeholder: "请选择" },
                                on: { focus: _vm.handleSelectFocus },
                                model: {
                                  value: _vm.searchForm.campusName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "campusName", $$v)
                                  },
                                  expression: "searchForm.campusName"
                                }
                              },
                              _vm._l(_vm.campusOptions, function(item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: Object.values(item)[0],
                                    value: Object.values(item)[0]
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "工单等级" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { clearable: "", placeholder: "请选择" },
                                model: {
                                  value: _vm.searchForm.ticketLevel,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "ticketLevel", $$v)
                                  },
                                  expression: "searchForm.ticketLevel"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "一级", value: "1" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "二级", value: "2" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "三级", value: "3" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "工单状态" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { clearable: "", placeholder: "请选择" },
                                model: {
                                  value: _vm.searchForm.order_status,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.searchForm,
                                      "order_status",
                                      $$v
                                    )
                                  },
                                  expression: "searchForm.order_status"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "已派单", value: "已派单" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "待派单", value: "待派单" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c(
                        "div",
                        { staticClass: "search-button" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.handleSearch }
                            },
                            [_vm._v("点击查询")]
                          ),
                          _c("el-button", { on: { click: _vm.handleReset } }, [
                            _vm._v("重置")
                          ]),
                          _c(
                            "el-button",
                            { on: { click: _vm.debouncedExport } },
                            [_vm._v(_vm._s(_vm.exportButtonText))]
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "title-en" }, [_vm._v("PO时效列表")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "table-container" },
          [
            _c("div", { staticClass: "button-container" }, [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "warning" },
                      on: {
                        click: function() {
                          _vm.searchForm.expiration_info = 1
                          _vm.handleSearch()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "预超时(" +
                          _vm._s(_vm.preTimeoutCount) +
                          ")\n          "
                      )
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: {
                        click: function() {
                          _vm.searchForm.expiration_info = 2
                          _vm.handleSearch()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "已超时(" + _vm._s(_vm.timeoutCount) + ")\n          "
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("el-button", { on: { click: _vm.openHeaderSettings } }, [
                    _vm._v("表头设置")
                  ])
                ],
                1
              )
            ]),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                attrs: { data: _vm.faults, border: "", stripe: "" },
                on: { "selection-change": _vm.handleSelectionChange }
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "55" }
                }),
                _vm._l(_vm.visibleColumns, function(col) {
                  return _c("el-table-column", {
                    key: col.prop,
                    attrs: {
                      prop: col.prop,
                      label: col.label,
                      width: col.width,
                      "min-width": col.minWidth
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              col.prop === "index"
                                ? [_vm._v(" " + _vm._s(scope.$index + 1) + " ")]
                                : col.prop === "createTime"
                                ? [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          scope.row[col.prop]
                                            ? _vm
                                                .$moment(scope.row[col.prop])
                                                .format("YYYY-MM-DD HH:mm:ss")
                                            : "-"
                                        ) +
                                        "\n            "
                                    )
                                  ]
                                : col.prop === "campusName"
                                ? [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.campusName ===
                                          "张家口-怀来东园"
                                          ? "怀来-东园"
                                          : scope.row[col.prop] || "-"
                                      )
                                    )
                                  ]
                                : col.prop === "SlALevel"
                                ? [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          scope.row[col.prop] === "1"
                                            ? "一级"
                                            : scope.row[col.prop] === "2"
                                            ? "二级"
                                            : scope.row[col.prop] === "3"
                                            ? "三级"
                                            : scope.row[col.prop] || "-"
                                        ) +
                                        "\n            "
                                    )
                                  ]
                                : col.prop === "opTicketid"
                                ? [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            scope.row.order_status ===
                                              "待派单" ||
                                            scope.row.order_status === "已派单"
                                              ? "https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=" +
                                                scope.row.opTicketid +
                                                "&isHistory=1"
                                              : "https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=" +
                                                scope.row.opTicketid,
                                          target: "_blank"
                                        }
                                      },
                                      [_vm._v(_vm._s(scope.row.opTicketid))]
                                    )
                                  ]
                                : col.prop === "po_status"
                                ? [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type:
                                            scope.row[col.prop] === "已确认"
                                              ? "success"
                                              : scope.row[col.prop] === "待确认"
                                              ? "warning"
                                              : "info",
                                          size: "small"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(scope.row[col.prop] || "-") +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ]
                                : col.prop === "order_status"
                                ? [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type:
                                            scope.row[col.prop] === "已派单"
                                              ? "success"
                                              : scope.row[col.prop] === "待派单"
                                              ? "warning"
                                              : "info",
                                          size: "small"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(scope.row[col.prop] || "-") +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ]
                                : col.prop === "feedback_status"
                                ? [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type:
                                            scope.row[col.prop] === "正常"
                                              ? "success"
                                              : scope.row[col.prop] === "预超时"
                                              ? "warning"
                                              : scope.row[col.prop] === "已超时"
                                              ? "danger"
                                              : "info",
                                          size: "small"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(scope.row[col.prop] || "-") +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  ]
                                : [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(scope.row[col.prop] || "-") +
                                        "\n            "
                                    )
                                  ]
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                })
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "pagination-container" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "page-sizes": [10, 20, 30, 50],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "设置显示项",
            visible: _vm.headerSettingsVisible,
            "append-to-body": true,
            width: "400px",
            "close-on-click-modal": false,
            "custom-class": "columns-dialog",
            "modal-append-to-body": false,
            "destroy-on-close": true
          },
          on: {
            "update:visible": function($event) {
              _vm.headerSettingsVisible = $event
            }
          }
        },
        [
          _c(
            "el-checkbox-group",
            {
              staticClass: "checkbox-group",
              model: {
                value: _vm.selectedColumns,
                callback: function($$v) {
                  _vm.selectedColumns = $$v
                },
                expression: "selectedColumns"
              }
            },
            _vm._l(_vm.allColumns, function(col) {
              return _c(
                "el-checkbox",
                {
                  key: col.prop,
                  staticClass: "checkbox-item",
                  attrs: { label: col.prop }
                },
                [_vm._v("\n        " + _vm._s(col.label) + "\n      ")]
              )
            }),
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: { click: _vm.handleSelectAll }
                },
                [_vm._v("全选")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: { click: _vm.restoreDefaults }
                },
                [_vm._v("恢复默认")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.saveHeaderSettings }
                },
                [_vm._v("保存")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }